export default __webpack_public_path__ + "static/media/examination.44229b13.svg";